/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const moreBtn = () => {
		if (document.querySelector('.js-more_6_all')) {
			document.querySelector('.js-more-btn').addEventListener('click', e => {
				document.querySelector('.js-more_6_all').classList.add(a);
				document.querySelector('.js-more-btn').classList.add('di_none');
			});
		}
		if (document.querySelectorAll('.js-more_6_all > li').length > 6) {
			if (document.querySelector('.js-more-btn')) {
				document.querySelector('.js-more-btn').classList.remove('di_none');
			}
		}
	};
	moreBtn();


	// 絞り込み
	const campaignList = document.querySelector('.js-campaign-list');
	const createList = (query) => {
		if (document.querySelector(".js-campaign-list")) {
			const getJSONfiles = () => {
				return `/ajax/campaign.json${query || ""}`
			}

			fetch(getJSONfiles())
				.then(function (response) {
					return response.json();
				})
				.then(function (jsonData) {



					const loadMoreHandler = () => loadItems(jsonData);

					document.querySelector(".js-campaign-list").innerHTML = "";
					if (jsonData.rt_bn_campaign_list.length > 0) {
						loadItems(jsonData);
					} else {
						const li = document.createElement('li');
						li.textContent = "現在、実施中のキャンペーンはありません。";
						campaignList.appendChild(li);
					}
				})
				.catch(error => console.error('Error fetching data:', error));
		}
	}

	const loadItems = (jsonData) => {
		campaignList.innerHTML += generateHTML(jsonData.rt_bn_campaign_list);

		FUNCTIONS.fileSize();
	};

	const generateHTML = (data) => {
		return data.map(item => `
			<li class="__column_2 __column_tab_2 __column_sp_1">
				<a href="${item.rt_cf_n_href_json_1 - 3?.href || item.rt_cf_n_href_json_4?.href}" 
					target="${item.rt_cf_n_href_json_1 - 3?.target || item.rt_cf_n_href_json_4?.target || "_self"}" 
					class="campaign-item rt_cf_n_href_campaign">

					<figure class="mod-imgWrap-radius10 mod-imgWrap-570_380">
						<img src="${item.rt_cf_n_thum_img.src || ""}" alt="${item.rt_cf_n_thum_img.alt || ""}" title="${item.rt_cf_n_thum_img.title || ""}" class="" loading="lazy">
					</figure>

					${item.rt_cf_n_type4_is_json !== null ? `
					<div class="campaign-item-scheduleWrap">
						<ul class="campaign-item-schedule">
							<li class="campaign-item-schedule-head"><span class="campaign-item-schedule-head-label">開始</span></li>
							<li class="fw_bold campaign-item-schedule-body">${item.rt_cf_n_start_date_EE.content}</li>
						</ul>
						<ul class="campaign-item-schedule">
							<li class="campaign-item-schedule-head"><span class="campaign-item-schedule-head-label">終了</span></li>
							<li class="fw_bold campaign-item-schedule-body">${item.rt_cf_n_end_date_EE.content}</li>
						</ul>
					</div>
					` : ''}
					
					<p class="campaign-item-title mod-spacer_20 fw_bold rt_cf_n_title">
						${item.rt_cf_n_title.content.map(content =>
			typeof content === 'object' && content.tag === 'br'
				? '<br>'
				: content
		).join('')}
						${generateFileInfo(item)}
					</p>
					
					<ul class="mod-tags _pink mod-spacer_20">
					${item.cf_n_tags
				.map(tag => `<li><span>${tag.cf_nt_name}</span></li>`)
				.join('')}
					</ul>
				</a>
			</li>
		`).join('');
	}

	const generateFileInfo = (item) => {
		let fileInfo = '';

		if (item.rt_cf_n_type2_is_json) {
			if (item.rt_cf_n_type2_pdf_is_json) {
				fileInfo += '<svg aria-hidden="true"><use xlink:href="/dydo_common/svg/sprite.svg#pdf"></use></svg>';
			} else if (item.rt_cf_n_type2_pdf_is_not_json) {
				fileInfo += '<svg aria-hidden="true"><use xlink:href="/dydo_common/svg/sprite.svg#document"></use></svg>';
			}
			if (item.rt_cf_n_attachment_file_size) {
				fileInfo += ` <span>(<span class="js-fileSize">${item.rt_cf_n_attachment_file_size.content}</span>)</span>`;
			}
		}

		if (item.rt_cf_n_type3_is_json) {
			if (item.rt_cf_n_type3_ext_link_is_json) {
				fileInfo += '<svg aria-hidden="true"><use xlink:href="/dydo_common/svg/sprite.svg#blank"></use></svg>';
			}
			if (item.rt_cf_n_type3_pdf_is_json) {
				fileInfo += '<svg aria-hidden="true"><use xlink:href="/dydo_common/svg/sprite.svg#pdf"></use></svg>';
			}
			if (item.rt_cf_n_url_file_size) {
				fileInfo += ` <span>(<span class="js-fileSize">${item.rt_cf_n_url_file_size.content}</span>)</span>`;
			}
		}

		return fileInfo;
	}

	const initEventNarrowDownBtn = () => {
		let btns = document.querySelectorAll('.js-campaign-nallow-down-btn');
		addEventNarrowDownBtn(btns);
	}

	const addEventNarrowDownBtn = (btns) => {
		if (btns.length == 0) return;

		const addEventButton = (button) => {
			button.addEventListener('click', (e) => {

				const clickedButton = e.currentTarget;
				const clickedDataType = clickedButton.getAttribute('data-name');

				if (clickedButton.classList.contains('is-active')) {
					clickedButton.classList.remove('is-active');
				} else {
					const isAll = clickedButton.getAttribute('data-is-all') === 'true';
					if (isAll) {
						document.querySelectorAll(`[data-name="${clickedDataType}"]`).forEach(btn => {
							if (btn !== clickedButton) {
								btn.classList.remove('is-active');
							}
						});
					} else {
						clickedButton.classList.add('is-active');
						document.querySelectorAll(`[data-name="${clickedDataType}"]`).forEach(btn => {
							if (btn.getAttribute('data-is-all') === 'true') {
								btn.classList.remove('is-active');
							}
						});
					}
				}

				const allInactiveExceptAll = Array.from(document.querySelectorAll(`[data-name="${clickedDataType}"]`)).every(btn => {
					return !btn.classList.contains('is-active');
				});

				const allButton = document.querySelector(`[data-name="${clickedDataType}"][data-is-all="true"]`);

				if (allInactiveExceptAll && allButton && !allButton.classList.contains('is-active')) {
					allButton.classList.add('is-active');
				}

				createList(createQuery());
			});
		}


		btns.forEach(button => {

			const tagId = button.getAttribute('data-id');
			const getJSONfiles = () => {
				return `/ajax/campaign/${tagId || ""}.json`
			}
			if(!tagId) {
				addEventButton(button);
			} else {
				fetch(getJSONfiles())
				.then(function (response) {
					return response.json();
				})
				.then(function (jsonData) {

					if (jsonData.rt_bn_campaign_exist.length == 0) {
						button.classList.add("is-disabled");
					} else {
						addEventButton(button);
					}
				})
				.catch(error => console.error('Error fetching data:', error));
			}
		});
	}

	const createQuery = () => {
		let queryArray = [];
		const activeButtons = document.querySelectorAll('.js-campaign-nallow-down-btn.is-active');
		activeButtons.forEach(button => {
			const dataName = button.getAttribute('data-name');
			const dataValue = button.getAttribute('data-value');

			if (dataName && dataValue) {
				queryArray.push(`${encodeURIComponent(dataName)}=${encodeURIComponent(dataValue)}`);
			}
		});

		let queryString = '';
		if (queryArray.length > 0) {
			queryString = '?' + queryArray.join('&');
		}

		return queryString;
	}

	if (campaignList) {
		initEventNarrowDownBtn();
		createList("");
	}
})(window.FUNCTIONS);
